export default {
  SESSION_ERROR_CODE: 'session_error',
  SESSION_ERROR_DESCRIPTION: 'Unknown session ID',
};
